var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRiskReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79409 15.171V4.06241M8.79409 15.171L7.70098 14.0779C7.08372 13.4606 6.24691 13.1138 5.37397 13.1138H2.62195C2.16749 13.1138 1.7998 12.7454 1.7998 12.291V3.65098C1.7998 3.19653 2.16821 2.82812 2.62266 2.82812H5.78502C6.65796 2.82812 7.49515 3.1749 8.11241 3.79216L8.79409 4.47384L9.47577 3.79216C10.093 3.1749 10.9302 2.82812 11.8032 2.82812H15.3769C15.8314 2.82812 16.1998 3.19653 16.1998 3.65098V12.291C16.1998 12.7454 15.8314 13.1138 15.3769 13.1138H12.2146C11.3416 13.1138 10.5045 13.4606 9.8872 14.0779L8.79409 15.171Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRiskReport);
export default __webpack_public_path__ + "static/media/IconRiskReport.737ae7fdb5c210ad25aad2cbf63827da.svg";
export { ForwardRef as ReactComponent };